import { useState } from "react";
import { Button } from "@mui/material";
import { syncYm } from "../../utils/syncClient";
import { useSnackbar } from "notistack";
import { COLORS } from "../../utils/colors";

export default function YmSyncButton({ setReloadToken }) {
  const [loading, setLoading] = useState(false);
  const { enqueueSnackbar } = useSnackbar();

  return (
    <Button
      size="small"
      variant="contained"
      sx={{
        bgcolor: COLORS.YM.bgcolor,
        color: COLORS.YM.color,
      }}
      onClick={async () => {
        try {
          setLoading(true);
          await syncYm();
          enqueueSnackbar("Заказы Яндекс.Маркета обновлены", {
            variant: "success",
          });
          setReloadToken((x) => x + 1);
        } catch (e) {
          console.error("[ym-sync] fail", e);
          enqueueSnackbar("Синхронизация Яндекс.Маркета не удалась", {
            variant: "error",
          });
        } finally {
          setLoading(false);
        }
      }}
      disabled={loading}
    >
      {loading ? "СИНХРОНИЗАЦИЯ…" : "ОБНОВИТЬ YM"}
    </Button>
  );
}
